
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"66.377","height":"83.139","viewBox":"0 0 17.562 21.997"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","clipPathUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":"M653.239 809.761H1884.24v-691H653.239z"}})]),_c('clipPath',{attrs:{"id":"b","clipPathUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"d":"M0 1080h1920V0H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#b)","transform":"matrix(.35278 0 0 -.35278 -275.89 359.833)"}},[_c('path',{attrs:{"d":"M806.94 963.619c-10.432 0-18.918 8.487-18.918 18.917 0 10.432 8.486 18.918 18.918 18.918 10.43 0 18.918-8.486 18.918-18.918 0-10.43-8.487-18.917-18.918-18.917m17.226 36.867l2.726 3.849a1.55 1.55 0 01-.37 2.16l-4.11 2.91a1.55 1.55 0 01-2.16-.37l-2.792-3.942a24.683 24.683 0 01-6.593 2.024v1.605c0 1.026.84 1.866 1.866 1.866h1.03c1.028 0 1.868.84 1.868 1.867v5.678c0 1.027-.84 1.867-1.868 1.867h-13.648a1.871 1.871 0 01-1.866-1.867v-5.678c0-1.026.839-1.867 1.866-1.867h1.03c1.028 0 1.868-.84 1.868-1.866v-1.605a24.635 24.635 0 01-7.035-2.236l-2.767 3.906a1.55 1.55 0 01-2.16.369l-4.11-2.91a1.548 1.548 0 01-.368-2.16l2.79-3.941c-4.517-4.507-7.315-10.737-7.315-17.61 0-13.724 11.167-24.89 24.892-24.89s24.89 11.166 24.89 24.89c0 7.048-2.942 13.419-7.664 17.95","fill":"var(--text-color)"}}),_c('path',{attrs:{"d":"M822.536 982.661c-.067 8.543-7.037 15.474-15.596 15.474-.042 0-.083-.004-.124-.004v-15.47h-15.472c-.001-.04-.003-.082-.003-.125 0-8.56 6.93-15.528 15.475-15.596l.124-.002c8.6 0 15.599 6.996 15.599 15.598 0 .043-.003.084-.003.125","fill":"var(--text-color)"}})])])
          )
        }
      }
    